import React from 'react';
import { motion } from 'framer-motion';
export function Services() {
  const services = [{
    title: 'Class A Motorhome',
    desc: 'Safe and secure nationwide RV transport for luxury Class A motorhomes, drive-away or towed.',
    img: 'https://cdn.magicpatterns.com/uploads/ahBRvT6LQK9CCdu3e8CvY3/Class_a.png'
  }, {
    title: 'Class B Camper Van',
    desc: 'Specialized handling and fast shipping logistics for camper vans and adventure vehicles.',
    img: 'https://cdn.magicpatterns.com/uploads/qsZ2zMKBGw7WKMiXcdLCax/class_b.png'
  }, {
    title: 'Class C Motorhome',
    desc: 'Expert transport coordination for Class C motorhomes, ensuring safe hauling coast-to-coast.',
    img: 'https://cdn.magicpatterns.com/uploads/rBYwWtWzY8tC7QMUKNvUZT/class_c.png'
  }, {
    title: 'Travel Trailer',
    desc: 'Dedicated transport solutions designed specifically for the safe hauling of travel trailers.',
    img: 'https://cdn.magicpatterns.com/uploads/xcDV6qjF7hr7LHKCg8V5gt/Travel_Trailer.png'
  }, {
    title: 'Fifth Wheel',
    desc: 'Affordable and reliable transport for large fifth-wheel trailers, handled by experienced RV movers.',
    img: 'https://cdn.magicpatterns.com/uploads/rHDQZvdQnAH3DLFwcKaZE2/5th_wheel_rv.png'
  }, {
    title: 'Toy Hauler',
    desc: 'Secure transport for toy haulers, ensuring your RV and cargo arrive safely at your destination.',
    img: 'https://cdn.magicpatterns.com/uploads/gYWbZHGLCSLnCRgerQXCQ2/RV_Toy_Hauler.png'
  }];
  return <section className="py-20 bg-brand-navy text-white" data-id="element-287">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-288">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-289">
          <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-290">
            Comprehensive RV Transport Services
          </h2>
          <p className="text-lg text-slate-300" data-id="element-291">
            From travel trailers to luxury Class A motorhomes, our RV movers
            have the equipment and expertise to handle any RV hauling
            requirement.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-292">
          {services.map((service, index) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} key={index} className="group relative overflow-hidden rounded-2xl bg-brand-navy-light border border-white/10" data-id="element-293">
              <div className="aspect-w-16 aspect-h-9 w-full h-64 overflow-hidden" data-id="element-294">
                <img src={service.img} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-295" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy via-brand-navy/40 to-transparent" data-id="element-296"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-297">
                <h3 className="text-2xl font-bold mb-2" data-id="element-298">{service.title}</h3>
                <p className="text-slate-300" data-id="element-299">{service.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}